import React, {useState} from 'react';
import './App.css';
import Chart from "react-google-charts";
import Firebase from 'firebase';
import config from './config';
import sortBy from 'lodash/sortBy';
import Select from 'react-select';
Firebase.initializeApp(config);

function App() {
  const [firebaseData, setFirebaseData] = useState(null);
  const [playersData, setPlayersData] = useState(null);
  const [playersBase, setPlayersBase] = useState(null);
  const [teamsBase, setTeamsBase] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [initValue, setInitValue] = useState(null);
  const writeUserData = (team) => {
    Firebase.database().ref(`/teamSchedule/${team}/votes`).set(Firebase.database.ServerValue.increment(1));
  }

  const playerData = (team, player) => {
    Firebase.database().ref(`/teamSchedule/${team}/players/${player}/votes`).set(Firebase.database.ServerValue.increment(1));
  }

  const handleChange = (selectedOption) => {
    if(localStorage.getItem("myIPLTeam2020")){
      return
    }
    setSelectedOption(selectedOption);
    writeUserData(selectedOption.value);
    localStorage.setItem("myIPLTeam2020", selectedOption.value);
  }
  const playerChange = (selectedOption) => {
    if(localStorage.getItem("myIPLPlayer2020")){
      return
    }
    setSelectedPlayer(selectedOption);
    let team = null;
    let player = null;
    Object.keys(initValue).forEach((item, index) => {
      initValue[item].players.forEach((val,ind)=>{
        if(val.value == selectedOption.value){
          team = item;
          player = ind;
        }
      })
    })
    playerData(team, player);
    localStorage.setItem("myIPLPlayer2020", selectedOption.value);

  }
  
  
  const getUserData = () => {
    let ref = Firebase.database().ref('/teamSchedule');
    ref.on('value', snapshot => {
      const valueArray = [["Team", "Fans", { role: "style" }]];
      const playersArray = [["Players", "Fans", { role: "style" }]];
      const playersBase = [];
      const teamsBase = [];
      const values = snapshot.val();
      setInitValue(values);
      Object.keys(values).map((item) => {
        teamsBase.push({value: item, label: item})
        valueArray.push([item, values[item].votes, values[item].color ])
        playersBase.push(...values[item].players);
      })
      setTeamsBase(teamsBase);
      setFirebaseData(valueArray);
      setPlayersBase(playersBase);
      playersBase && sortBy(playersBase, 'votes').reverse().map((item)=>{
        playersArray.push([item.label.split(" ")[0]+item.label.split(" ")[1], item.votes, "coral"])
      })
      setPlayersData(playersArray)

    });
  }

  useState(()=>{
    getUserData();
  },[])

  console.log(localStorage.getItem("myIPLTeam2020"))

  return (
    <div className="App">
        <div className="Header">Cricket Fanz <span> - Live Fan Meter</span></div>
        <div>
          <div className="SubHeader" onClick={()=>{writeUserData()}}>Most followed IPL 2020 Team:</div>
          <div>
             {firebaseData && <Chart
              chartType="ColumnChart"
              width="100%"
              height="400px"
              data={firebaseData}
              options={{
                chartArea: { width: '60%', height: '85%'},
                vAxis: {
                  title: 'Fans',
                },
              }}
            />}
          </div>
          <div>
            <br/>
            <div className="SubHeader">Vote for your Team: {localStorage.getItem("myIPLTeam2020")}</div>
          {!localStorage.getItem("myIPLTeam2020") && <div className="TextBox"><Select
            value={selectedOption}
            onChange={handleChange}
            options={teamsBase}
            defaultOptions
          /></div>}
          </div>

        </div>
        <div>
          <br/>
          <div className="SubHeader">Most followed IPL Players:</div>
          <div style={{padding:10}}>
              {playersData && <Chart
              chartType="BarChart"
              width="96"
              height="1100px"
              data={playersData.slice(0,30)}
              options={{
                title: 'Top 30 Players IPL 2020',
                chartArea: { width: '52%', height: '85%'},
                hAxis: {
                  title: 'Total Votes',
                  minValue: 0,
                }
              }}
            />}
          </div>
          <div className="SubHeader">Your Favorite Player: {localStorage.getItem("myIPLPlayer2020")}</div>
          {!localStorage.getItem("myIPLPlayer2020") && <div className="TextBox"> <Select
            value={selectedPlayer}
            onChange={playerChange}
            options={playersBase}
            defaultOptions
          /></div>}
          </div>
        </div>
  );
}

export default App;
